class CountdownTimerClassic extends HTMLElement {
  constructor() {
    super();
    this.timeLeft = {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    };
    this.timer = null;
    this.title = "";
    this.elements = {};

    // Default translations
    this.translations = {
      days: {
        singular: 'TAG',
        plural: 'TAGE'
      },
      hours: {
        singular: 'STD',
        plural: 'STD'
      },
      minutes: {
        singular: 'MIN',
        plural: 'MIN'
      },
      seconds: {
        singular: 'SEK',
        plural: 'SEK'
      }
    };
  }

  static get observedAttributes() {
    return ['target-date', 'translations', 'title'];
  }

  connectedCallback() {
    this.title = this.getAttribute('main-title');
    this.link = this.getAttribute('link');
    const $this = this
    if (this.link) {
      $this.style.cursor = 'pointer'
    }
    this.addEventListener('click', () => {
      if ($this.link) {
        window.location.href = $this.link;
      }
    });
    this.loadTranslations();
    this.createElements();
    this.startTimer();
  }

  disconnectedCallback() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'target-date' && oldValue !== newValue) {
      this.startTimer();
    }
    if (name === 'translations' && oldValue !== newValue) {
      this.loadTranslations();
      this.updateDisplay(); // Update labels with new translations
    }
  }

  loadTranslations() {
    const translationsAttr = this.getAttribute('translations');
    if (translationsAttr) {
      try {
        const customTranslations = JSON.parse(translationsAttr);
        this.translations = {
          ...this.translations,
          ...customTranslations
        };
      } catch (e) {
        console.error('Invalid translations format:', e);
      }
    }
  }

  createElements() {
    // Container
    const container = document.createElement('div');
    container.className = 'ds-timer-classic__container';

    const title = document.createElement('div');
    title.className = 'ds-timer-classic__title';
    title.innerHTML = this.title;

    if (this.title && this.title != 'null') {
      container.appendChild(title);
    }

    const countdownContainer = document.createElement('div');
    countdownContainer.className = 'ds-timer-classic__countdown';

    // Create number row
    const numberRow = document.createElement('div');
    numberRow.className = 'ds-timer-classic__number-row';

    // Create label row
    const labelRow = document.createElement('div');
    labelRow.className = 'ds-timer-classic__label-row';

    // Create units (days, hours, minutes, seconds)
    const units = ['days', 'hours', 'minutes', 'seconds'];

    units.forEach((unit, index) => {
      // Create number container
      const numberContainer = document.createElement('div');
      numberContainer.className = 'ds-timer-classic__number-container';

      // Create number element
      const number = document.createElement('span');
      number.className = 'ds-timer-classic__number';
      this.elements[`${unit}-number`] = number;
      numberContainer.appendChild(number);

      // Create label container
      const labelContainer = document.createElement('div');
      labelContainer.className = 'ds-timer-classic__label-container';

      // Create label element
      const label = document.createElement('span');
      label.className = 'ds-timer-classic__label';
      this.elements[`${unit}-label`] = label;
      labelContainer.appendChild(label);

      // Add containers to their respective rows
      numberRow.appendChild(numberContainer);
      labelRow.appendChild(labelContainer);

      // Add separator if not last item
      if (index < units.length - 1) {
        const numberSeparator = document.createElement('div');
        numberSeparator.className = 'ds-timer-classic__separator';
        numberSeparator.textContent = ':';
        numberRow.appendChild(numberSeparator);

        const labelSeparator = document.createElement('div');
        labelSeparator.className = 'ds-timer-classic__separator ds-timer-classic__separator--label';
        labelSeparator.innerHTML = '&nbsp;';
        labelRow.appendChild(labelSeparator);
      }
    });

    // Add both rows to countdown container
    countdownContainer.appendChild(numberRow);
    countdownContainer.appendChild(labelRow);

    // Add countdown container to main container
    container.appendChild(countdownContainer);

    // Clear and append new content
    this.replaceChildren(container);
  }

  calculateTimeLeft() {
    const targetDate = new Date(this.getAttribute('target-date'));
    const now = new Date();
    const difference = targetDate.getTime() - now.getTime();

    if (difference <= 0) {
      this.dispatchEvent(new CustomEvent('countdown-complete'));
      return {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      };
    }

    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60)
    };
  }

  startTimer() {
    if (this.timer) {
      clearInterval(this.timer);
    }

    this.timeLeft = this.calculateTimeLeft();
    this.updateDisplay();

    this.timer = setInterval(() => {
      this.timeLeft = this.calculateTimeLeft();
      this.updateDisplay();

      if (Object.values(this.timeLeft).every(value => value === 0)) {
        clearInterval(this.timer);
      }
    }, 1000);
  }

  padNumber(num) {
    return String(num).padStart(2, '0');
  }

  getLabel(unit, value) {
    const translation = this.translations[unit];
    if (!translation) return '';
    return value === 1 ? translation.singular : translation.plural;
  }

  updateDisplay() {
    Object.entries(this.timeLeft).forEach(([unit, value]) => {
      // Update number
      const numberElement = this.elements[`${unit}-number`];
      if (numberElement) {
        numberElement.textContent = this.padNumber(value);
      }

      // Update label with singular/plural form
      const labelElement = this.elements[`${unit}-label`];
      if (labelElement) {
        labelElement.textContent = this.getLabel(unit, value);
      }
    });
  }
}

// Register the web component
if (!customElements.get('countdown-timer-classic')) {
  customElements.define('countdown-timer-classic', CountdownTimerClassic);
}
